import React from "react";
import OfflineReportsV2Page from "./pages/OfflineReportsV2Page";

export default function MainReportV2() {
  return <OfflineReportsV2Page />;
}